import { useCart as coreUseCart } from "@shopware/composables"
import type { Schemas } from '#shopware'

/**
 * Extended useCart composable
 * Extends the core Shopware useCart with additional functionality
 *
 * @category Cart & Checkout
 * @returns Extended cart functions and state
 */
export function useCart() {
    const coreFunctionality = coreUseCart()

    /**
     * Calculate total quantity of all products in cart
     * Sums up the quantity of each line item
     *
     * @returns Total quantity of all products
     */
    const totalProductQuantity = computed(() => {
        return coreFunctionality.cart.value?.lineItems?.reduce((total: number, item: Schemas['LineItem']) => {
            return total + (item.quantity || 0)
        }, 0) || 0
    })

    return {
        ...coreFunctionality,
        totalProductQuantity
    }
}
